module.exports = __webpack_public_path__ + "static/invidzonen-964d4729df7604ad72a894ac97302fdd.png";